import { SVGProps } from 'react';

const SvgApplePodcast = ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <title>Apple Podcast</title>
    <g id="Podcasts_(iOS)" clipPath="url(#clip0_11083_41903)">
      <g id="XMLID_632_">
        <path
          id="XMLID_662_"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M29.41 26C29.12 26.74 28.45 27.78 27.49 28.52C26.94 28.94 26.28 29.35 25.38 29.62C24.42 29.91 23.23 30 21.75 30H8.25C6.77 30 5.59 29.9 4.62 29.62C3.72 29.35 3.06 28.95 2.51 28.52C1.56 27.79 0.88 26.74 0.59 26C0.00999999 24.51 0 22.82 0 21.75V8.25C0 7.18 0.00999999 5.49 0.59 4C0.88 3.26 1.55 2.22 2.51 1.48C3.06 1.06 3.72 0.65 4.62 0.38C5.59 0.1 6.77 0 8.25 0H21.75C23.23 0 24.41 0.1 25.38 0.38C26.28 0.65 26.94 1.05 27.49 1.48C28.44 2.21 29.12 3.26 29.41 4C30 5.49 30 7.19 30 8.25V21.75C30 22.82 29.99 24.51 29.41 26Z"
          fill="url(#paint0_linear_11083_41903)"
        />
        <g id="Group">
          <path
            id="XMLID_657_"
            d="M17.5702 18.11C17.5302 17.75 17.4102 17.49 17.1702 17.25C16.7202 16.78 15.9302 16.47 15.0002 16.47C14.0702 16.47 13.2802 16.77 12.8302 17.25C12.6002 17.5 12.4702 17.75 12.4302 18.11C12.3502 18.81 12.4002 19.41 12.4802 20.38C12.5602 21.3 12.7102 22.53 12.9002 23.77C13.0402 24.66 13.1502 25.14 13.2502 25.48C13.4202 26.04 14.0302 26.52 15.0002 26.52C15.9702 26.52 16.5902 26.03 16.7502 25.48C16.8502 25.14 16.9602 24.66 17.1002 23.77C17.2902 22.52 17.4402 21.3 17.5202 20.38C17.6102 19.41 17.6502 18.81 17.5702 18.11Z"
            fill="white"
          />
          <path
            id="XMLID_655_"
            d="M17.46 13.0099C17.46 14.3699 16.36 15.4699 15 15.4699C13.64 15.4699 12.54 14.3699 12.54 13.0099C12.54 11.6499 13.64 10.5499 15 10.5499C16.36 10.5499 17.46 11.6599 17.46 13.0099Z"
            fill="white"
          />
          <path
            id="XMLID_653_"
            d="M14.9701 3.31996C9.23011 3.33996 4.53011 7.99996 4.45011 13.74C4.39011 18.39 7.36011 22.37 11.5101 23.83C11.6101 23.87 11.7101 23.78 11.7001 23.68C11.6501 23.32 11.5901 22.96 11.5501 22.6C11.5301 22.47 11.4501 22.37 11.3401 22.31C8.06011 20.88 5.77011 17.59 5.81011 13.78C5.86011 8.77996 9.94011 4.70996 14.9301 4.66996C20.0401 4.62996 24.2101 8.76996 24.2101 13.87C24.2101 17.64 21.9301 20.88 18.6801 22.31C18.5601 22.36 18.4801 22.47 18.4701 22.6C18.4201 22.96 18.3701 23.32 18.3201 23.68C18.3001 23.79 18.4101 23.87 18.5101 23.83C22.6201 22.39 25.5701 18.47 25.5701 13.87C25.5501 8.04996 20.8001 3.30996 14.9701 3.31996Z"
            fill="white"
          />
          <path
            id="XMLID_651_"
            d="M14.7302 6.81991C10.9902 6.95991 7.99023 10.0499 7.94023 13.7899C7.91023 16.2499 9.14023 18.4299 11.0302 19.7199C11.1202 19.7799 11.2502 19.7099 11.2502 19.5999C11.2202 19.1699 11.2202 18.7899 11.2402 18.3899C11.2502 18.2599 11.2002 18.1399 11.1002 18.0499C9.95023 16.9699 9.25023 15.4299 9.29023 13.7299C9.37023 10.7299 11.7802 8.28991 14.7802 8.16991C18.0402 8.03991 20.7202 10.6599 20.7202 13.8799C20.7202 15.5199 20.0202 16.9999 18.9102 18.0499C18.8202 18.1399 18.7702 18.2599 18.7702 18.3899C18.7902 18.7799 18.7802 19.1599 18.7602 19.5899C18.7502 19.6999 18.8802 19.7799 18.9802 19.7099C20.8402 18.4399 22.0702 16.2899 22.0702 13.8699C22.0802 9.88991 18.7502 6.65991 14.7302 6.81991Z"
            fill="white"
          />
        </g>
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_11083_41903"
        x1="15"
        y1="0"
        x2="15"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F452FF" />
        <stop offset="1" stop-color="#832BC1" />
      </linearGradient>
      <clipPath id="clip0_11083_41903">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgApplePodcast;
